import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  useMediaQuery
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import seasons from "../../seasons";

const SeasonSelect = ({ season, onSeasonChange }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleSeasonChange = (e) => onSeasonChange(e.target.value);

  return (
    <FormControl
      size="small"
      sx={{ minWidth: 200, mt: isSmallScreen ? 2 : 0 }}
      fullWidth={isSmallScreen}
    >
      <InputLabel id="season-select-label">Season</InputLabel>
      <Select
        label="Season"
        onChange={handleSeasonChange}
        labelId="season-select-label"
        id="season-select"
        value={season?.id}
      >
        {seasons.map((s) => (
          <MenuItem key={s.id} value={s.id}>
            {s.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

SeasonSelect.propTypes = {
  season: PropTypes.object,
  onSeasonChange: PropTypes.func.isRequired
};

export default SeasonSelect;
